export default __webpack_public_path__ + "static/media/Leah 9781408312872.74459e8b.jpg";